import React, { useState } from "react";

import { useFormContext, useFormState } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ErrorMessage, RequiredMark } from "@components/inputs/shared";
import classNames from "classnames";

import { PopoverMessage } from ".";
import { FormSelectFieldProps } from "./types";

const FormSelectField = (props: FormSelectFieldProps) => {
	const {
		name,
		className,
		labelClassName,
		label,
		inputClassName = undefined,
		dropdownData = [],
		placeholder = undefined,
		required = false,
		validate,
		errorMessage = undefined,
		popoverMsg = null,
		selected,
		pattern,
		property = "name",
		keyValue = "id",
		...rest
	} = props;

	const [showPopoverMsg, setShowPopoverMsg] = useState(false);

	const { t } = useTranslation();
	const { register } = useFormContext();

	const { errors } = useFormState();
	const error = errors?.name;

	const field = register(name, {
		required: {
			value: required,
			message: errorMessage || "COMMON.REQUIRED_FIELD",
		},
		pattern,
		validate,
	});

	const labelClasses = classNames("label", labelClassName);

	const inputClass = classNames(
		inputClassName,
		{
			"input input--base":
				inputClassName == undefined || inputClassName == null,
		},
		"input--select",
		{
			"input-validation-error": error != undefined,
		}
	);

	if (label == undefined || className == undefined) {
		return (
			<>
				{/* @ts-expect-error - error because value can be null*/}
				<select id={name} className={inputClass} {...field} {...rest}>
					{placeholder ? (
						<option value="">{t(placeholder)}</option>
					) : null}

					{dropdownData?.map((value) => {
						return (
							<option
								key={value?.[keyValue]}
								value={value?.[keyValue]}
							>
								{t(value?.[property])}
							</option>
						);
					})}
				</select>
			</>
		);
	}

	return (
		<div className={className}>
			<label
				htmlFor={name}
				className={labelClasses}
				onClick={(e) => {
					e.preventDefault();
					e.stopPropagation();
					setShowPopoverMsg(true);
				}}
			>
				{t(label)}
				<RequiredMark required={required} />
				<PopoverMessage
					showPopoverMsg={showPopoverMsg}
					setShowPopoverMsg={setShowPopoverMsg}
					popoverMsg={popoverMsg}
				/>
			</label>

			<ErrorMessage name={name} />
			{/* @ts-expect-error - error because value can be null*/}
			<select
				id={name}
				className={inputClass}
				defaultValue={selected}
				{...field}
				{...rest}
			>
				{placeholder ? (
					<option value="">{t(placeholder)}</option>
				) : null}

				{dropdownData?.map((value) => {
					return (
						<option
							key={value?.[keyValue]}
							value={value?.[keyValue]}
						>
							{t(value?.[property])}
						</option>
					);
				})}
			</select>
		</div>
	);
};

export default FormSelectField;
